/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileTabs_tradeFirm = {
    readonly publicProfile: {
        readonly designProjectsCount: number | null;
        readonly portfolios: ReadonlyArray<{
            readonly itemCount: number | null;
        } | null> | null;
    } | null;
    readonly " $refType": "ProfileTabs_tradeFirm";
};
export type ProfileTabs_tradeFirm$data = ProfileTabs_tradeFirm;
export type ProfileTabs_tradeFirm$key = {
    readonly " $data"?: ProfileTabs_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileTabs_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProfileTabs_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "designProjectsCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "portfolios",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioV1",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "itemCount",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '83cd147dbc9aa7ec256f94ec88b47870';
export default node;
